import { render, staticRenderFns } from "./Lgpd.vue?vue&type=template&id=6e8b3cf4&"
import script from "./Lgpd.vue?vue&type=script&lang=js&"
export * from "./Lgpd.vue?vue&type=script&lang=js&"
import style0 from "./Lgpd.vue?vue&type=style&index=0&id=6e8b3cf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports